<form [formGroup]="activationEmailTemplateForm">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="templateName" class="control-label required">{{
        'i18n.domain.export-configuration.activation-email-templates.activation-email-form.form-fields.template-name' |
        translate }}</label>
      <input id="templateName" type="text" class="form-control" formControlName="templateName" />
      <app-error-messages [control]="activationEmailTemplateForm.get('templateName')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.general.form-fields.transfer-type' | translate }}</label>
      <app-enum-drop-down-list formControlName="transferType" [showClearButton]="false" [enumType]="TransferType"
        baseTranslationString='i18n.shared.transferTypes.'>
      </app-enum-drop-down-list>
      <app-error-messages [control]="activationEmailTemplateForm.get('transferType')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label class="control-label required">{{'i18n.domain.export-configuration.activation-email-templates.activation-email-form.form-fields.output-email-account' | translate }}</label>
      <ejs-dropdownlist id="outputEmailAccountId" formControlName="emailAccountId" [dataSource]="outputEmailAccounts"
        [fields]="outputEmailAccountFields" [allowFiltering]="true">
      </ejs-dropdownlist>
      <app-error-messages [control]="activationEmailTemplateForm.get('emailAccountId')"></app-error-messages>
    </div>
  </div>
</form>
<app-email-form [emailForm]="activationEmailTemplateForm" [showPlaceholders]="true" [showLoadFromTemplateButton]="false" [showOutputEmailAccountField]="false"></app-email-form>
